module.exports = {
	"title": "findify-layouts--recommendation--slider__title",
	"arrow": "findify-layouts--recommendation--slider__arrow",
	"scrollBarContainer": "findify-layouts--recommendation--slider__scrollBarContainer",
	"scrollBar": "findify-layouts--recommendation--slider__scrollBar"
};